import React, { useContext } from 'react';
import {
  Box,
  Flex,
  Drawer,
  DrawerBody,
  Icon,
  useColorModeValue,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
} from '@chakra-ui/react';

import Content from 'components/sidebar/components/Content';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { IoMenuOutline } from 'react-icons/io5';
import { SidebarContext } from 'contexts/SidebarContext';

/* DESKTOP SIDEBAR */

function Sidebar({ routes }) {
  const { isCollapsed, setIsCollapsed } = useContext(SidebarContext);
  const sidebarBg = useColorModeValue('white', 'navy.800');

  return (
    <Box
      position="fixed"
      left="0"
      top="0"
      h="100vh"
      display={{ base: 'none', xl: 'block' }}
      zIndex="100"
    >
      <Box
        bg={sidebarBg}
        transition="width 0.25s ease"
        w={isCollapsed ? '80px' : '300px'}
        h="100vh"
      >
        <Flex justify="flex-end" p="10px">
          <Icon
            as={IoMenuOutline}
            w="22px"
            h="22px"
            cursor="pointer"
            onClick={() => setIsCollapsed((p) => !p)}
          />
        </Flex>

        <Scrollbars autoHide style={{ height: 'calc(100vh - 50px)' }}>
          <Content routes={routes} collapsed={isCollapsed} />
        </Scrollbars>
      </Box>
    </Box>
  );
}

/* MOBILE DRAWER */

export function SidebarResponsive({ routes }) {
  const { isDrawerOpen, setIsDrawerOpen } = useContext(SidebarContext);
  const sidebarBg = useColorModeValue('white', 'navy.800');

  return (
    <Drawer
      isOpen={isDrawerOpen}
      placement="left"
      onClose={() => setIsDrawerOpen(false)}
    >
      <DrawerOverlay />
      <DrawerContent bg={sidebarBg}>
        <DrawerCloseButton />
        <DrawerBody p="0">
          <Content routes={routes} collapsed={false} />
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
}

export default Sidebar;
